import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AuthService } from '../../../../services/auth.service';
var forgotPwdComponent = /** @class */ (function () {
    function forgotPwdComponent(activeModal, authAPIs) {
        this.activeModal = activeModal;
        this.authAPIs = authAPIs;
        this.showErrorMsg = false;
        this.showLoader = false;
    }
    forgotPwdComponent.prototype.ngOnInit = function () {
        this.createForm();
    };
    forgotPwdComponent.prototype.createForm = function () {
        this.forgotPwdForm = new FormGroup({
            email: new FormControl('', [Validators.required, Validators.pattern(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)])
        });
    };
    forgotPwdComponent.prototype.closeModal = function () {
        this.activeModal.close();
    };
    forgotPwdComponent.prototype.forgotPwdFun = function () {
        var _this = this;
        this.showLoader = true;
        this.authAPIs.forgotPwd(this.forgotPwdForm.value).subscribe(function (res) {
            _this.showLoader = false;
            if (res.success === true) {
                _this.showSuccess = true;
            }
            else if (res.statusCode === 105 && res.success === false) {
                _this.showErrorMsg = true;
            }
            else {
                // console.log(res.message);
            }
        });
    };
    return forgotPwdComponent;
}());
export { forgotPwdComponent };



// WEBPACK FOOTER //
// ./src/app/modules/user/auth/forgot-pwd/forgot-pwd.component.ts.pre-build-optimizer.js